import React, { useEffect } from "react";

/**
 * Bottom sheet modal. Slides up from bottom, rounded top, handle bar,
 * tap outside to close, max-height 85vh, scrollable content.
 */
export default function BottomSheet({ open, onClose, title, children, testId }) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "";
      };
    }
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center fade-anim"
      data-testid={testId}
    >
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
        data-testid={testId ? `${testId}-overlay` : undefined}
      />
      <div
        className="relative w-full max-w-[380px] bg-white rounded-t-[20px] shadow-2xl sheet-anim"
        style={{ maxHeight: "85vh" }}
      >
        <div className="flex justify-center pt-3 pb-1">
          <div className="w-10 h-1.5 bg-slate-300 rounded-full" />
        </div>
        {title && (
          <div className="px-5 pt-2 pb-3">
            <h2 className="text-lg font-bold tracking-tight text-slate-900">
              {title}
            </h2>
          </div>
        )}
        <div
          className="px-5 pb-6 overflow-y-auto"
          style={{ maxHeight: "calc(85vh - 60px)" }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
